import React, { useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { TagsFill } from "react-bootstrap-icons";
import "../options/Categorization.scss";
import { SketchPicker } from 'react-color';

function HandCategorization() {

    const [categories, setCategories] = useState({ levelColors: [], names: [] });
    const [modified, setModified] = useState(false);

    const categoryNameChanged = (index, name) => {
        console.log(index, name);
        let copy = JSON.parse(JSON.stringify(categories));
        copy.names[index] = name;
        setCategories(copy);
        setModified(true);
    }
    const categoryColorChanged = (index, color, event) => {
        console.log(index, color);
        let copy = JSON.parse(JSON.stringify(categories));
        copy.levelColors[index].red = color.rgb.r;
        copy.levelColors[index].green = color.rgb.g;
        copy.levelColors[index].blue = color.rgb.b;
        copy.levelColors[index].alpha = color.rgb.a;
        setCategories(copy);
        setModified(true);
    }

    const cancel = () => {
        let colorsConfiguration = JSON.parse(window.handBridge.getColorsConfiguration());
        setCategories(colorsConfiguration);
        setModified(false);
    }

    const save = () => {
        let colorsConfiguration = JSON.parse(JSON.stringify(categories));
        colorsConfiguration.levelColors.forEach((level) => {
            delete (level.rgb);
            delete (level.transparency);
            delete (level.colorSpace);
        });
        window.handBridge.updateColorsConfiguration(JSON.stringify(colorsConfiguration));
        setModified(false);
        window.onHandCategoriesUpdate(categories);
    }

    useEffect(() => {
        let timer = null;
        if (window.handBridge) {
            let colorsConfiguration = JSON.parse(window.handBridge.getColorsConfiguration());
            setCategories(colorsConfiguration);
        } else {
            timer = setInterval(() => {
                if (window.handBridge) {
                    let colorsConfiguration = JSON.parse(window.handBridge.getColorsConfiguration());
                    setCategories(colorsConfiguration);
                    clearInterval(timer);
                }
            }, 100);
        }

        return (() => {
            if (timer) {
                clearInterval(timer);
            }
        });
    }, []);

    return (
        <div className="options-categorization">
            <div className="header">Hand categorization</div>
            <div className="description">Choisissez les noms et couleurs des catégories de main</div>
            {categories.levelColors.map((level, index) =>
                index < 10 ?
                    <div className="row" key={"category" + index} onClick={() => { }}>
                        <Dropdown className="categories" >
                            <Dropdown.Toggle variant="success">
                                <TagsFill size="24" style={{ color: "rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")" }}></TagsFill>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <SketchPicker className="color" color={"rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")"} onChange={(color, evt) => categoryColorChanged(index, color, evt)}></SketchPicker>
                            </Dropdown.Menu>
                            <input type="text" value={categories.names[index]} onChange={(evt) => categoryNameChanged(index, evt.target.value)} />
                        </Dropdown>
                    </div> : <></>
            )
            }
            <div className="actions"><Button className="cancel" disabled={!modified} onClick={cancel}>Cancel</Button><Button className="save" disabled={!modified} onClick={save}>Save</Button></div>
        </div>);
}
export default HandCategorization;